<div class="wrapper flex column">
  <app-header [heading]="'EVENTS.HEADER.TITLE' | translate"></app-header>
  <main class="events-container grow1 flex column">
    <div
      id="events-table-filters"
      class="flex"
    >
      <app-events-case-id-filter></app-events-case-id-filter>
      <app-events-debtor-name-filter></app-events-debtor-name-filter>
      <payee-case-client-filter
        [searchClients]="searchClients"
        [resolveClient]="resolveClient"
      ></payee-case-client-filter>
      <app-events-label-filter></app-events-label-filter>
      <app-events-date-filter></app-events-date-filter>
      <app-events-clear-filters></app-events-clear-filters>
    </div>

    @if (!loading && dataSource.data.length > 0) {
      <app-events-table
        [dataSource]="dataSource"
        [pagination]="pagination"
        [showClientColumn]="showClientColumn()"
        (page)="pageChange($event)"
      ></app-events-table>
    }

    @if (!loading && dataSource.data.length === 0) {
      <h1 id="no-event-found-text">
        {{ "EVENTS.EMPTY" | translate }}
      </h1>
    }

    @if (loading) {
      <div class="events-skeleton-table">
        <table
          mat-table
          class="skeleton-table mat-elevation-z1"
          [dataSource]="skeletonDataSource"
        >
          @for (col of skeletonColumns(); track col) {
            <ng-container [matColumnDef]="col">
              <th
                *matHeaderCellDef
                mat-header-cell
              >
                <div class="skeleton-line skeleton-header"></div>
              </th>
              <td
                *matCellDef
                mat-cell
              >
                <div class="skeleton-line"></div>
              </td>
            </ng-container>
          }
          <tr
            *matHeaderRowDef="skeletonColumns()"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: skeletonColumns()"
            mat-row
          ></tr>
        </table>
      </div>
    }
  </main>
</div>
